import * as React from 'react'
import './ThreeColumnImageText.scss'
import { Grid } from '../grid'
import { Carousel } from '../carousel'
import ThreeColumnItem from './ThreeColumnItem'
import { default as Data } from '../../models/threeColumnImageText'

export type Props = {
    threeColumnData: Data
}

class ThreeColumnImageText extends React.Component<Props> {
    state = {
        width: 0,
        height: 0,
    }

    componentDidMount() {
        this.updateWindowDimensions()
        window.addEventListener('resize', this.updateWindowDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions)
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight })
    }

    render() {
        const {
            threeColumnData,
        } = this.props

        return (
            <Grid>
                <div className='threeColumn'>
                    <h2 className='threeColumn__main-title'>{threeColumnData.title}</h2>
                    {this.state.width < 768 ?
                    <div className='threeColumn__carousel'>
                        <Carousel icon='alternative'>
                            <ThreeColumnItem
                                title={threeColumnData.titleOne}
                                body={threeColumnData.bodyOne}
                                imageUrl={threeColumnData.imageOne}
                                footer={threeColumnData.footerOne}
                            />
                            <ThreeColumnItem
                                title={threeColumnData.titleTwo}
                                body={threeColumnData.bodyTwo}
                                imageUrl={threeColumnData.imageTwo}
                                footer={threeColumnData.footerTwo}
                            />
                            <ThreeColumnItem
                                title={threeColumnData.titleThree}
                                body={threeColumnData.bodyThree}
                                imageUrl={threeColumnData.imageThree}
                                footer={threeColumnData.footerThree}
                            />
                        </Carousel>
                    </div>
                    :
                    <div className='row'>
                        <ThreeColumnItem
                            title={threeColumnData.titleOne}
                            body={threeColumnData.bodyOne}
                            imageUrl={threeColumnData.imageOne}
                            footer={threeColumnData.footerOne}
                        />
                        <ThreeColumnItem
                            title={threeColumnData.titleTwo}
                            body={threeColumnData.bodyTwo}
                            imageUrl={threeColumnData.imageTwo}
                            footer={threeColumnData.footerTwo}
                        />
                        <ThreeColumnItem
                            title={threeColumnData.titleThree}
                            body={threeColumnData.bodyThree}
                            imageUrl={threeColumnData.imageThree}
                            footer={threeColumnData.footerThree}
                        />
                    </div>}
                </div>
            </Grid>
        )
    }
}

export default ThreeColumnImageText
